import { TopbarContainer } from './Topbar.elements';

import { useContext } from 'react';
import { AuthContext } from '../../context/authentication/Auth.context';
import { LayoutContext } from '../../context/layouts/Layout.context';

const Topbar = () => {
  const { currentUser }: any = useContext(AuthContext);
  const { showSidebar, onShowSidebar } = useContext(LayoutContext);
  return (
    <TopbarContainer>
      <nav>
        <div className="container">
          <h1 className="brand">Account-Storage</h1>
          <div className="profile-area">
            {/* <div className="theme-btn">
          <span className="material-icons-sharp active"> light_mode </span>
          <span className="material-icons-sharp"> dark_mode </span>
        </div> */}
            <div className="profile">
              {/* <div className="profile-photo">
              <img src="https://i.pravatar.cc/150?img=61" alt="profile" />
            </div> */}
              <h5>{currentUser.username}</h5>
            </div>
            <button
              id="menu-btn"
              type="button"
              onClick={() => onShowSidebar(!showSidebar)}
            >
              <span className="material-icons-sharp"> menu </span>
            </button>
          </div>
        </div>
      </nav>
    </TopbarContainer>
  );
};

export default Topbar;
